export const DEV = "https://zazio-89059772666.us-central1.run.app/api";
// export const PRODUCTION = "https://admin.tyrewaale.com/api";

//Dev Api URL
//https://zazio-89059772666.us-central1.run.app//api

//production API URL
//https://zazio-1027856261586.us-central1.run.app/api

//staging API URL
//https://zazio-89059772666.us-central1.run.app//api

//staging commands firebase
// firebase target:apply hosting staging staging123
//firebase deploy --only hosting:staging

//production commands firebase
//firebase target:apply hosting zazio zazio-1dddb
//firebase deploy --only hosting:zazio

// latest move4wrd server url
// https://zazio-89059772666.us-central1.run.app
